import EmployeesHeaderPanel from './EmployeesHeaderPanel';

export default EmployeesHeaderPanel;
